import { chakra } from "@chakra-ui/react";
import logoWhite from "./logo-white.svg";
import logoBlack from "./logo-black.svg";
import icon from "./almond-icon.jpg";

export enum VariantTypes {
  "white",
  "black",
}

interface props {
  props?: any;
  ref?: "img";
  variant?: VariantTypes;
}

export const Logo = ({ props, ref, variant }: props) => (
  <chakra.img
    w="full"
    src={variant === VariantTypes.white ? logoWhite : logoBlack}
    ref={ref}
    {...props}
  />
);
export const Icon = ({ props, ref, variant }: props) => (
  <chakra.img
    w="full"
    src={icon}
    ref={ref}
    {...props}
  />
);
